module.exports = __webpack_public_path__ + "media/vraag_4_antwoord.f2594597.mp3";